import * as moment from 'moment';
import { TemplateService } from '../../services/template.service';
import { CALENDAR_LOCALE } from '../../services/constant';
import { ApiService } from '../../services/api.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { HttpParams } from '@angular/common/http';
import { AuthenticationService } from '../../services/authentication.service';
var OperationLogComponent = (function () {
    function OperationLogComponent(authenticationService, modalService, apiService, template) {
        this.authenticationService = authenticationService;
        this.modalService = modalService;
        this.apiService = apiService;
        this.template = template;
        this.startDate = new Date(moment().format('YYYY') + '-01-01');
        this.endDate = new Date(moment().format('YYYY') + '-12-30');
        this.loading = false;
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.errors = [];
        this.selectedCustomercode = null;
        this.checkdate = null;
        this.defaultLabel = null;
        this.sortBy = null;
        this.sortMode = null;
        this.no_data = true;
        this.errorMsg = '';
        this.allDeliverycode = true;
        this.allDocType = true;
        this.selectedValues = [];
        this.usernames = [];
        this.roles = [];
        this.tableCol = [];
        this.loading_excel_report = false;
        this.currentPage = 1;
        this.itemsPerPage = 40;
        this.totalItems = 0;
    }
    OperationLogComponent.prototype.ngOnInit = function () {
        this.clearSearch();
        this.searchButtonClicked();
    };
    OperationLogComponent.prototype.ngOnDestroy = function () {
        if (this.subs) {
            this.subs.unsubscribe();
        }
    };
    OperationLogComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    OperationLogComponent.prototype.sort = function (event) {
        this.sortBy = event.field;
        if (event.order === 1) {
            this.sortMode = '';
        }
        else {
            this.sortMode = '-';
        }
    };
    OperationLogComponent.prototype.clearSearch = function () {
        this.searchUsername = '';
        this.searchRole = '';
        this.searchAction = '';
        this.searchDetail = '';
        this.loadSearch();
    };
    OperationLogComponent.prototype.loadSearch = function () {
        var _this = this;
        this.loadUsers();
        this.loadRoles();
        this.loadActions();
        this.loadDates();
        this.tableCol = [];
        var columnsToAdd = [
            { field: 'created_at', header: 'วันเวลา' },
            { field: 'role', header: 'สิทธิ์การเข้าถึง' },
            { field: 'actor', header: 'ชื่อผู้ใช้' },
            { field: 'action', header: 'รายละเอียดการใช้งาน' },
            { field: 'address', header: 'ส่วนที่ใช้งาน' },
        ];
        columnsToAdd.forEach(function (col) {
            if (!_this.tableCol.some(function (existingCol) { return existingCol.field === col.field; })) {
                _this.tableCol.push(col);
            }
        });
        this.currentPage = 1;
    };
    OperationLogComponent.prototype.loadUsers = function () {
        var _this = this;
        this.usernames = [];
        this.usernames = [{
                'label': 'ทั้งหมด',
                'value': ''
            }];
        this.loading = true;
        this.apiService.getUsers().subscribe(function (response) {
            if (response && Array.isArray(response.results)) {
                _.forEach(response.results, function (user) {
                    if (user) {
                        _this.usernames.push({
                            'label': user.username || 'Unknown',
                            'value': user.id
                        });
                    }
                });
            }
            else {
                console.error('Expected response.results to be an array, received:', response);
            }
            _this.loading = false;
            _this.usernames = _.uniqBy(_this.usernames, 'label');
        }, function (error) {
            _this.loading = false;
            console.log('error', error);
        });
    };
    OperationLogComponent.prototype.loadRoles = function () {
        var _this = this;
        this.roles = [];
        this.roles = [{
                'label': 'ทั้งหมด',
                'value': ''
            }];
        this.loading = true;
        var params = {};
        if (!this.authenticationService.isAdmin()) {
            params = { source: 'action-logs' };
        }
        this.apiService.getGroups(params).subscribe(function (roles) {
            _.forEach(roles, function (role) {
                _this.roles.push({
                    'label': role.name,
                    'value': role.id
                });
            });
            _this.loading = false;
            _this.roles = _.uniqBy(_this.roles, 'label');
        }, function (error) {
            _this.loading = false;
            console.log('error', error);
        });
    };
    OperationLogComponent.prototype.loadActions = function () {
        var _this = this;
        this.actions = [];
        this.actions = [{
                'label': 'ทั้งหมด',
                'value': ''
            }];
        this.loading = true;
        this.apiService.getActions().subscribe(function (actions) {
            _.forEach(actions.results, function (action) {
                _this.actions.push({
                    'label': action.value,
                    'value': action.name
                });
            });
            _this.loading = false;
            _this.actions = _.uniqBy(_this.actions, 'label');
        }, function (error) {
            _this.loading = false;
            console.log('error', error);
        });
    };
    OperationLogComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
        if (this.endDate < this.minDate) {
            this.endDate = this.minDate;
        }
    };
    OperationLogComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
        if (this.startDate > this.maxDate) {
            this.startDate = this.maxDate;
        }
    };
    Object.defineProperty(OperationLogComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = new Date().getFullYear();
            return thisYear - 40 + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OperationLogComponent.prototype, "dateRange", {
        get: function () {
            var start = moment(this.startDate).format('DD/MM/YYYY');
            var end = moment(this.endDate).format('DD/MM/YYYY');
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    OperationLogComponent.prototype.loadDates = function () {
        this.defaultLabel = 'ทั้งหมด';
        this.defaultLabel = 'ทั้งหมด';
        this.startDate = new Date();
        this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
        this.endDate = new Date();
    };
    OperationLogComponent.prototype.sentDate = function () {
        this.checkdate = 1;
    };
    OperationLogComponent.prototype.searchButtonClicked = function () {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        this.searchData();
    };
    OperationLogComponent.prototype.searchData = function (params) {
        var _this = this;
        this.loading = true;
        this.checkCondition();
        if (this.errorMsg.length > 0) {
            this.loading = false;
            return;
        }
        var data = {
            page: this.currentPage,
            items_per_page: this.itemsPerPage,
            actor_id: this.searchUsername,
            role_id: this.searchRole,
            action: this.searchAction,
            detail: this.searchDetail,
            start_date: moment(this.startDate).format('YYYY-MM-DD'),
            end_date: moment(this.endDate).format('YYYY-MM-DD')
        };
        if (this.sortBy) {
            if (this.sortBy === 'action') {
                data['ordering'] = this.sortMode + this.sortBy + ',' + this.sortMode + 'target';
            }
            else {
                data['ordering'] = this.sortMode + this.sortBy;
            }
        }
        if (this.currentPage === 1) {
            params = null;
        }
        this.apiService.getSniffs(data).subscribe(function (result) {
            _this.loading = false;
            _this.tempTableData = result.results;
            _this.tableData = _this.tempTableData.map(function (resultData) {
                resultData.action_display = resultData['action_display'] + ' - ' + resultData['detail'];
                resultData.address_display = resultData['feature_display'];
                return resultData;
            });
            _this.no_data = _.isEmpty(_this.tempTableData);
            if (result) {
                _this.totalItems = result.count;
            }
            return _this.tempTableData;
        }, function (error) {
            _this.loading = false;
            _this.no_data = true;
            _this.errorMsg = 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง';
        });
    };
    OperationLogComponent.prototype.checkCondition = function () {
        this.errorMsg = '';
        var errorMsgList = [];
        if (_.isEmpty(this.deliverycode) && this.allDeliverycode === false) {
            errorMsgList.push('รหัสการจัดส่ง');
        }
        if (_.isEmpty(this.documentType) && this.allDocType === false) {
            errorMsgList.push('Doc Type');
        }
        if (errorMsgList.length > 0) {
            this.errorMsg = 'กรุณาระบุ'
                + ' ' + errorMsgList.join(', ')
                + ' ' + 'ให้ถูกต้อง';
            return;
        }
    };
    OperationLogComponent.prototype.clearData = function () {
        this.clearSearch();
        this.tableData = undefined;
        this.no_data = true;
        this.startDate = new Date();
        this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
        this.endDate = new Date();
        this.selectedCustomercode = null;
        this.selectedDeliverycode = null;
        this.selectedRdDocumentType = null;
        this.deliverycode = null;
        this.documentType = null;
        this.notApprove = false;
        this.allDocType = true;
        this.allDeliverycode = true;
        this.sortBy = null;
        this.sortMode = null;
        this.selectedValues = [];
        this.searchButtonClicked();
    };
    OperationLogComponent.prototype.pageChanged = function () {
        var params = new HttpParams();
        params = params.append('page', this.currentPage.toString());
        this.searchData(params);
    };
    OperationLogComponent.prototype.DownloadReport = function () {
        var _this = this;
        this.loading_excel_report = true;
        var params = {
            actor_id: this.searchUsername,
            role_id: this.searchRole,
            action: this.searchAction,
            detail: this.searchDetail,
            start_date: moment(this.startDate).format('YYYY-MM-DD'),
            end_date: moment(this.endDate).format('YYYY-MM-DD')
        };
        this.apiService.getOperationsLogExcelReport(params).subscribe(function (obj) {
            var filename = 'operations_log_report' + '.xlsx';
            _this.apiService.createDownloadFile(obj, filename);
            _this.loading_excel_report = false;
            _this.sniff('DOWNLOAD_EXCEL', filename);
        }, function (error) {
            _this.loading_excel_report = false;
        });
    };
    OperationLogComponent.prototype.sniff = function (action, detail) {
        var data = {
            action: action,
            feature: 'OPERATION_LOG',
            detail: detail
        };
        this.apiService.sniff(data).subscribe(function (res) {
        });
    };
    return OperationLogComponent;
}());
export { OperationLogComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/operation-log/operation-log.component.ts.pre-build-optimizer.js